import jqUaAddcls from "@/assets/js/functions/jquery.ua_addclass.js";
import jsImgLink from "@/assets/js/functions/setImageLink.js";
import jsLsObj from "@/assets/js/functions/resetLsData.js";
import jsReset from "@/assets/js/functions/resetSaveObj.js";
import jsStg from "@/assets/js/functions/class_localStorage.js";
import ie from "@/assets/js/functions/checkIE.js";
import _, { divide } from "lodash";
import { forEach } from "core-js/fn/array";
// import jqFixed from "@/assets/js/functions/class_jqFixedWindow.js"
var ls = new jsStg.jsLocalStorage();
// var fw = new jqFixed.jqfixedWindow();

export default {
  name: "result",
  props: {
    title: String,
    title_html: String,
    title_id: String,
    ls_key: String,
    jsonObj: Object,
    SettingObj: Object,
  },
  data: function() {
    return {
      headerTitle: "",
      head_id: 0,
      qAry: [],
      bool: {
        confirm: false,
        bookmark: false,
        active_expl: false,
        explanation: false,
        hasImage : false
      },
      data: { explanation: "" , imgId : ""},
      score: { current_q: 0, current_a: 0, total_q: 0, total_a: 0, percent: 0 },
      circleStyle : {
        display : 'inline-block',
        width: '10px',
        height : '10px',
        padding: '5px',
        marginRight : '5px',
        marginLeft : '5px',
        marginBottom: '5px',
        marginTop: '2px',
      //  margin : '2.5px',
        borderRadius: '50%',
        textAlign: 'center',
        fontSize: '10px',
        border:' 0.1em solid #666',
        boxSizing: 'initial'
      },
      blankStylings: {
        border: '2px solid rgba(0,153,220,1)', 
        minWidth: '33.33%',
        height: '30px',
        // paddingBottom : '30px',
        textAlign: 'center', 
        borderRadius: '3px', 
        // marginTop : '1.8px',
        display: 'inline-block',
      },
      imageStyle : {
        minWidth: '10%',
        minHeight : '50%'
      },
      questionColor: 'rgb(0, 84, 122) !important',
      bgcolors: {
        text: { color: this.SettingObj.bgcolors.text },
        display : 'inline',
        header: { background: this.SettingObj.bgcolors.header },
        footer: { background: this.SettingObj.bgcolors.footer },
        belt: { background: this.SettingObj.bgcolors.belt },
        title: { background: this.SettingObj.bgcolors.title },
        button_heavy: {
          background: this.SettingObj.bgcolors.button_heavy,
          borderBottom: this.SettingObj.bgcolors.button_heavy_thick,
        },
        result_bg: { background: this.SettingObj.bgcolors.result_bg },
      },
    };
  },
  created: function() {
    var ls_data = ls.getStorageJson(this.ls_key);
    this.head_id = ls_data.current_head_id;
    var head_id = this.head_id;
    this.headerTitle = this.jsonObj.qAry[head_id].header;
    
    // correctAryとbookmarkAryがランダムな並びの場合はソートして並びをリセット
    if (ls_data.continueBool) {
      ls_data.saveAry[head_id].correctAry.sort(function(a, b) {
        if (a.id < b.id) return -1;
        if (a.id > b.id) return 1;
        return 0;
      });
      ls_data.saveAry[head_id].bookmarkAry.sort(function(a, b) {
        if (a.id < b.id) return -1;
        if (a.id > b.id) return 1;
        return 0;
      });
    }

    // ユーザーが一通り解答完了済みであれば成績情報の集計を実行
    if (ls_data.saveAry[head_id].finishBool) {
      if (!ls_data.saveAry[head_id].percent) {
        ls_data.saveAry[head_id].total = { q: 0, a: 0 }; // 初期化
      }

      // 正解数をカウントしそれまでの正解数としてアプリ内に適用
      const correctAry = ls_data.saveAry[head_id].correctAry;
      var count = 0;
      for (i = 0; i < correctAry.length; i++) {
        if (correctAry[correctAry[i].id].bool) {
          count++;
        }
      }
      ls_data.saveAry[head_id].total.q =
        ls_data.saveAry[head_id].correctAry.length;
      ls_data.saveAry[head_id].total.a = count;
      ls_data.saveAry[head_id].percent = Math.floor(
        (ls_data.saveAry[head_id].total.a / ls_data.saveAry[head_id].total.q) *
          100
      );

      // 画面表示用に現在のdataへ代入
      this.score.current_q = ls_data.saveAry[head_id].cache.q;
      this.score.current_a = ls_data.saveAry[head_id].cache.a;
      this.score.total_q = ls_data.saveAry[head_id].total.q;
      this.score.total_a = ls_data.saveAry[head_id].total.a;
      this.score.percent = ls_data.saveAry[head_id].percent;

      var questions = this.jsonObj.qAry[head_id].questions;
      var userAnswerAry = ls_data.saveAry[head_id].answerAry
      var allGenre = ls_data.saveAry.length - 1; //all genre
    
      // 前回までの結果表示用にObjへ集約する
      for (var i = 0; i < ls_data.saveAry[head_id].correctAry.length; i++) {
        const id = ls_data.saveAry[head_id].correctAry[i].id;
        questions[id] = jsImgLink.setImageLink(questions[id]); // JSON内の画像ファイル名記述（【…】の半角文字）からリンクパスを取得し置換
        this.qAry[id] = {};
       // this.qAry[id].head_id = questions[id].head_id;

        if(allGenre == this.head_id){
          this.qAry[id].head_id = questions[id].head_id;
          this.qAry[id].origId = questions[id].origId
        }else{
          this.qAry[id].head_id = this.head_id;
          this.qAry[id].origId = questions[id].id
        }

        this.qAry[id].id = questions[id].id; // 第〜問
        this.qAry[id].text = questions[id].text; // 問題文
        this.qAry[id].select =
          questions[id].answers[ls_data.saveAry[head_id].correctAry[id].select]; // 選んだ答え
        this.qAry[id].answer = questions[id].answer; // 正解文
        if(userAnswerAry) {
          this.qAry[id].userAnswer = userAnswerAry[id] || "-"; // 正解文
        }

        this.qAry[id].explanation = questions[id].explanation; // 解説文
        this.qAry[id].active_expl = (questions[id].explanation == '') ? false : true; // 解説文
        this.qAry[id].result = ls_data.saveAry[head_id].correctAry[id].bool; // 現在までの正誤状況
        this.qAry[id].bookmark = ls_data.saveAry[head_id].bookmarkAry[id].bool; // 現在までの登録状況
        this.qAry[id].multiple = ls_data.saveAry[head_id].multiple[id];
        this.qAry[id].fixed = ls_data.saveAry[head_id].fixed[id];
        this.qAry[id].textEng = questions[id].textEng
        this.qAry[id].gid = questions[id].gid
     
        if(questions[id].imgId){ //for image
          this.qAry[id].imgId =  questions[id].imgId
        }

        this.qAry[id].image = false;
       
      }
      ls.setStorageJson(this.ls_key, ls_data);
    }
  },
  mounted: function() {
    // ユーザーエージェントよりclass属性（ua_sp、ua_tb、ua_pc）を追加
    jqUaAddcls.ua_addclass();
    this.changeHeaderPosition(); // IE/Edge header flicker fix.
    this.adjustCircle();
  },
  computed: {
    // ペンギンイラストの成績コメントを正解率に応じて定義
    result_comment: function() {
      var comment = "";
      if (this.score.percent === 0) {
        comment = "・・・";
      } else if (1 <= this.score.percent && 39 >= this.score.percent) {
        comment = "Oh no.";
      } else if (40 <= this.score.percent && 69 >= this.score.percent) {
        comment = "Wow！";
      } else if (70 <= this.score.percent && 99 >= this.score.percent) {
        comment = "Great";
      } else if (this.score.percent === 100) {
        comment = "Excellent !!";
      }
      return comment;
    }
  },
  methods: {
    // 問題登録処理イベント
    setBookmark: function(head_id, item_id, orig_id, gid) {
      var ls_data = ls.getStorageJson(this.ls_key);
      var allGenre = ls_data.saveAry.length - 1; //all genre
      let id = this.head_id == allGenre ? item_id : orig_id
      this.qAry[item_id].bookmark = !this.qAry[item_id].bookmark;
      this.qAry.splice(); // 配列への直接代入はリアクティブしないのでspliceで強制発火

        var qs = this.jsonObj.qAry[head_id].questions
        var allQs = this.jsonObj.qAry[allGenre].questions

        if(allGenre == this.head_id){
          if(ls_data.saveAry[head_id].bookmarkAry.length != qs.length){
            for(var i = 0; i<qs.length; i++){
              ls_data.saveAry[head_id].bookmarkAry[i] = {
                id: qs[i].id,
                bool: false,
              }
            }
          }

          if(ls_data.saveAry[head_id].correctAry.length != qs.length){

            for(var i = 0; i<qs.length; i++){
              ls_data.saveAry[head_id].correctAry[i] = {
                id: qs[i].id,
                bool: false,
                select: null,
              }
            }
          }
         
          ls_data.saveAry[head_id].bookmarkAry[orig_id] = {
            id: orig_id,
            bool: this.qAry[item_id].bookmark,
          };
        
          ls_data.saveAry[allGenre].bookmarkAry[item_id] = {// all genre, save bookmark for both all genre and the specific subject
            id: item_id,
            bool: this.qAry[item_id].bookmark,
          };

        }else{
          if(ls_data.saveAry[allGenre].bookmarkAry.length != allQs.length){
            for(var i = 0; i<allQs.length; i++){
              ls_data.saveAry[allGenre].bookmarkAry[i] = {
                id: allQs[i].id,
                bool: false,
              }
            }
          }

          if(ls_data.saveAry[allGenre].correctAry.length != allQs.length){
            for(var i = 0; i<allQs.length; i++){
              ls_data.saveAry[allGenre].correctAry[i] = {
                id: allQs[i].id,
                bool: false,
                select: null,
              }
            }
          }

          ls_data.saveAry[head_id].bookmarkAry[item_id] = {// all genre, save bookmark for both all genre and the specific subject
            id: item_id,
            bool: this.qAry[item_id].bookmark,
          };
        
          ls_data.saveAry[allGenre].bookmarkAry[gid] = {// all genre, save bookmark for both all genre and the specific subject
            id: gid,
            bool: this.qAry[item_id].bookmark,
          };
        }

      ls.setStorageJson(this.ls_key, ls_data);
      return;
    },
    // 解説ボタンイベント
    activeExplanation: function(head_id, item_id) {
      
      if (!this.bool.explanation) {
        const currentExplanation = this.jsonObj.qAry[head_id].questions[item_id].explanation;
        this.data.explanation = currentExplanation;
        this.bool.explanation = true;
        
        if(this.jsonObj.qAry[head_id].questions[item_id].imgId){
          this.data.imgId = this.jsonObj.qAry[head_id].questions[item_id].imgId
        }
        // fw.fixedWindow(".exp_window"); // 背面スクロールを禁止（jQuery）
      } else {
        this.data.explanation = "";
        this.bool.explanation = false;
        // fw.releaseWindow(".exp_window"); // 背面スクロール禁止を解除
      }

     
    },
    // ホームへ戻るときに saveAry[n].current をリセットして保存
    returnHome: function() {
      var ls_data = ls.getStorageJson(this.ls_key);
      const current_hd = ls_data.current_head_id;
      ls_data.saveAry[current_hd].current = 0;
      ls_data.saveAry[current_hd].cache = { q: 0, a: 0 };
      ls_data.saveAry[current_hd].total = { q: 0, a: 0 };

      ls.setStorageJson(this.ls_key, ls_data);
      this.$router.push("/");
      return;
    },
    returnSelection: function() {
      var ls_data = ls.getStorageJson(this.ls_key);
      const current_hd = ls_data.current_head_id;
      ls_data.saveAry[current_hd].current = 0;
      ls_data.saveAry[current_hd].index = 0;
      ls_data.saveAry[current_hd].cache = { q: 0, a: 0 };
      ls_data.saveAry[current_hd].total = { q: 0, a: 0 };

      ls.setStorageJson(this.ls_key, ls_data);
      this.$router.push("/selection");
      return;
    },

    numbered_answer : function(answer, fixed){
      if(fixed){
        let ans = answer.split(" ");
        let numbered = ans.filter(val => !fixed.includes(val));
        return numbered;
      }
    },
    switchConfirm: function() {
      this.bool.confirm = !this.bool.confirm;
    },
    removeStorage: function() {
      this.bool.confirm = !this.bool.confirm;
      this.$router.push("/");

      // アプリタイトル毎で保存データをすべて消去
      var ls_data = ls.getStorageJson(this.ls_key);
      const current_hd = ls_data.current_head_id; // 単元IDを消去前にキャッシュ
      ls.removeStorage(this.ls_key);
      location.reload(); // ブラウザキャッシュを消去するリロード

      // 消去後に保存用Objを初期化（Home.vueと共通）
      ls_data = jsLsObj.resetLsData(this.title, this.title_id); // ls_data Objを初期化
      ls_data.current_head_id = current_hd; // 単元ID情報のみ復帰
      ls_data.saveAry = jsReset.resetSaveObj(this.jsonObj.qAry); // 単元単位でls_data.saveAry[n]を初期化

      ls.setStorageJson(this.ls_key, ls_data);
      return;
    },
    adjustCircle : function(){

      if(ie.detectIEEdge()){
        this.circleStyle.width = '20px';
        this.circleStyle.height = '20px';
      }
    },
    checkHeaderTitle(header){ //for displaying math and english subjects
      let hd = header.split(" ");
			return hd[0];
    },
    checkRepeat : function(answer){
      let ans = answer.split(":")
      if(ans.length > 1){
        return ans[0]
      }

      return answer;
    },
    formatHtml: function(text) {
      let _text = text.replace(/\n/g, " :br ");
      _text = _text.replace(/\t/g, " :tab ");
      return this.getTextHtml(_text);
    },
    getTextReturn: function(text, index) {

      if (text === ":blank") return;
      if (text !== ":br" && text !== ":tab") {

       let ext = text.split('.').pop();
        if(ext === 'png' || ext === 'jpg'){
          this.hasImage=true;
        }else {
          return text;
        }
      }
    },
    imageChecker(text){
			let ext = text.split('.').pop();
			if(ext === 'png' || ext === 'jpg'){
				return true
			}
			return false;
    },
    imageGetter(text){
      let texts = text.split(" ");
			return texts;
		},
    getBlankStylings: function(text) {
      if (text !== ":blank") return {};
      
      return this.blankStylings;
    },
    getTextHtml: function(textEng, id) {
      let texts = textEng.split(" ");
      texts = _.map(
        texts,
        function(text) {
          if (!text.startsWith("b:")) {
            let ext = text.split('.').pop();
            if(ext === 'png' || ext === 'jpg'){
             this.qAry[id].image = true;
             return text;
            }else{
              return text;
            }
          }
          
          let blankCount = parseInt(text.substring(2));
          let blankDivs = [];

          for (let i = 0; i < blankCount; i++) {
            blankDivs.push(":blank");
          }
          return blankDivs;
        }.bind(this)
      );

      let blankIterator = 0;
      return _.chain(texts)
        .flatten()
        .map(
          function(it, key) {
            let item = { value: it, id: "no-id-" + key };
            if (it === ":blank") {
              item.id =
                "englishAnswer_" +
                this.currentPage +
                "_" +
                (key - blankIterator);
              item.index = key - blankIterator;
            } else {
              blankIterator++;
            }
            return item;
          }.bind(this)
        )
        .value();
    },
    changeHeaderPosition: function() {
      if (ie.detectIEEdge()) {
        document.getElementById("fix_header").style.position = "fixed";
        document.getElementById("content").style.marginTop = "250px";
        document.getElementsByClassName("speechbubble")[0].style.paddingTop = '30px';
      }
    },
  },
};
